<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <!-- <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Date" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="issued_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
              issued_at = {
                startDate: null,
                endDate: null,
              }
              ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Transaction Date From"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datefrom"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="Transaction Date From"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datefrom"
                        @click="datefrom = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Transaction Date To"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="dateto"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="Transaction Date To"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!dateto"
                        @click="dateto = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect placeholder="Select status..." v-model="status" :clearable="true"
                    :options="status_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- :disabled="!user.permissions.includes('bookingforms.admin')" -->
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Reason ( ? )" label-size="sm">
                  <treeselect v-model="reason" :clearable="true" :options="reason_options"></treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Payment Method" label-size="sm">
                  <treeselect v-model="payby" :clearable="true" :options="payby_options"></treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..." v-model="event"
                    :clearable="true" :async="true" :load-options="treeselect_loadEvent" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="options.debounce" placeholder="Your Ref/PO"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="ID ( Paste List )" label-for="id" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="id" v-model="id" tag-variant="primary" separator=" ,;"
                      placeholder="Paste ID (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="id = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="reflist1-tooltip" triggers="hover">Use ticket number in related fields? Check this
                  option to see
                  associated exchange and re-issued tickets.
                </b-tooltip>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Details" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="comments" :debounce="options.debounce" placeholder="Details"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!comments" @click="comments = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in tools.filter(
              (o) => o.position == 'toolbar'
            )" :key="index">
                    <b-button v-if="tool.type == 'button'" :id="'tool_' + tool.action" :size="tool.size"
                      :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null" :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)">
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col cols="auto" v-for="(tool, index) in options.view" :key="index">
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group v-if="tool.type == 'radio-group'" :options="tool.options">
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay :show="options.overlay_show" opacity=".9" v-click-outside="outside">
            <div>
              <b-table :dark="$store.state.darkMode" ref="btable" :sticky-header="btable_height + 'px'" striped hover
                small caption-bottom show-empty selectable select-mode="multi" :busy="btable_busy" :items="btable_items"
                :fields="options.fields" :filter="btable_find" @row-selected="btable_rowSelected">
                <template #head(selected)>
                  <i id="selectall" class="ml-1" :class="btable_iconselected()" aria-hidden="true"
                    @click="btable_iconselectedClick()" title="Click to select/unselect all"></i>
                  <b-tooltip target="selectall" triggers="hover" placement="right">Click to select/unselect
                    all</b-tooltip>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner type="grow" variant="primary" class="align-middle mr-2"></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div v-if="options.badges &&
              options.badges.find((obj) => obj.key == row.field.key)
              ">
                    <span v-html="btable_rowBadgeCell(
              row.item,
              options.badges.find(
                (obj) => obj.key == row.field.key
              ),
              options
            )
              "></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button variant="link" size="sm" title="Actions" :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')">
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover container="actions-container" triggers="click blur" placement="leftbottom"
                      :target="'popover-target-' + row.item.id">
                      <div>
                        <b-nav vertical>
                          <b-nav-item :title="action.label" v-for="action in btable_rowActionCell(
              row.item,
              options
            )" :key="action.key" @click.stop="btable_rowClick(action.key, row)">
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
              action.label
            }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="btable_rowActionIcon(action, row.item)
              "></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button variant="link" size="sm" v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key" @click.stop="btable_rowClick(action.key, row)" :title="action.label">
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component :is="options.component.name" :selection="btable_selected" :config="cconfig"
                      @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button v-for="(button, index) in options.overlay.buttons" :key="index"
                      :style="button.style ? button.style : 'width: 80px'" :class="button.class
              ? button.class
              : button.dispatch
                ? null
                : 'ml-2'
              " :variant="button.variant
              ? button.variant
              : button.dispatch
                ? 'outline-primary'
                : 'outline-secondary'
              " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true" @click="
              button.dispatch
                ? toolClick(button.dispatch)
                : (options.overlay_show = false)
              ">{{ button.label }}</b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="btable_selected" :config="cconfig" @saveit="saveit"
          @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3" no-gutters>
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary">Found {{ rows }} rows</span>


        </b-col>
        <b-col class="text-right">
          <b-pagination hide-ellipsis v-model="currentpage" :total-rows="rows" :per-page="limit" align="right"
            size="sm"></b-pagination>
        </b-col>
        <b-col class="ml-2" cols="auto">
          <div class="pagelimit">
            <treeselect v-model="limit" :clearable="false" :options="options_pagesizes" size="sm" inline></treeselect>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="errormessage">
        <b-col class="ml-3">
          <i class="fa fa-exclamation-circle text-danger"></i>
          <span class="ml-3 text-danger" v-html="errormessage"></span>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import BookingFormEdit from "./Components/BookingFormEdit";

export default {
  name: "BookingForms",
  components: { BookingFormEdit },
  watch: {
    async issued_at() {
      await this.load();
    },
    async event() {
      await this.load();
    },
    async slac() {
      await this.load();
    },
    async payby() {
      await this.load();
    },
    async reason() {
      await this.load();
    },
    async agent() {
      await this.load();
    },
    async status() {
      await this.load();
    },
    async yourref() {
      await this.load();
    },
    async comments() {
      await this.load();
    },
    async id() {
      await this.load();
    },
  },
  data() {
    return {
      issued_at: {
        startDate: this.$moment().add(-3, 'M').startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      event: null,
      slac: null,
      blac: null,
      payby: null,
      payby_options: [],
      reason: null,
      reason_options: [],
      agent: null,
      yourref: null,
      comments: null,
      id: [],
      status: null,
      status_options: [
        { id: "unsubmitted", label: "Unsubmitted" },
        { id: "submitted", label: "Submitted" },
        { id: "invoiced", label: "Invoiced" },
      ],
      errormessage: "",
      criteria: {
        events: [],
      },
      options: {
        title: "Booking Forms",
        icon: "fa fa-tasks",
        debounce: 500,
        tools: [],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "id",
            label: "ID",
            sortable: true,
          },
          {
            key: "modified",
            label: "Date and Time",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },
          {
            key: "reason",
            label: "?",
            sortable: true,
          },
          {
            key: "payby",
            label: "Pay",
            sortable: true,
            class: "text-center",
          },

          // {
          //   key: "date",
          //   label: "Date",
          //   sortable: true,
          //   class: "text-center",
          //   formatter: (value, key, item) => {
          //     let result = "";
          //     if (value) {
          //       result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
          //     }
          //     return result;
          //   },
          // },
          // {
          //   key: "blac",
          //   label: "Supplier",
          //   sortable: true,
          // },
          {
            key: "value",
            label: "Amount",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              }
            },
          },
          {
            key: "event",
            label: "Event",
            sortable: true,
          },
          {
            key: "slac",
            label: "S/L",
            sortable: true,
          },
          {
            key: "comments",
            label: "Details",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 60) {
                  result = result.slice(0, 57) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "charge",
            label: "to Client £",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              }
            },
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
          },
          {
            key: "invoiceno",
            label: "Invoice No",
            sortable: true,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "reason",
            type: "badge",
            H: "danger",
            F: "primary",
            C: "warning",
            M: "secondary",
            V: "info",
            X: "dark",
            Y: "dark",
            Z: "dark",
            T: "info",
          },
          {
            key: "status",
            type: "badge",
            unsubmitted: "info",
            submitted: "danger",
            invoiced: "primary",
          },
        ],
        actions: [
          {
            key: "edit",
            label: "Edit",
            icon: "fa fa-pencil",
            single: true,
            multiple: false,
            component: {
              name: "BookingFormEdit",
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  async mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    if (this.user.permissions.includes("bookingforms.delete")) {
      this.options.actions.push({
        key: "deleteit",
        label: "Delete",
        icon: "fa fa-trash text-danger",
        single: true,
        multiple: true,
        overlay: {
          message: "Are you sure you want to delete booking form %id% ?",
          buttons: [
            {
              label: "Yes",
              variant: "danger",
              dispatch: "deleteit",
            },
            {
              label: "No",
              class: "ml-2",
            },
          ],
        },
      });
    }

    if (this.user.permissions.includes("bookingforms.admin")) {
      this.agent = null;
      this.status = "submitted";
    } else {
      this.agent = this.user.initials;
    }

    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,import,archive");
    this.toolComponents([
      { action: "add", name: "BookingFormEdit" },
      { action: "edit", name: "BookingFormEdit" },
      // { action: "new", name: "BookingFormEdit2" },
    ]);

    this.loadDDL();
    this.load();
  },

  methods: {
    async loadDDL() {
      //this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingformspaytypes {
              bookingformspaytypes {
                id
                label             
              }
            }
          `,
        });
        this.payby_options = response.data.bookingformspaytypes;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingformsreasontypes {
              bookingformsreasontypes {
                id
                label: name
              }
            }
          `,
        });
        this.reason_options = response.data.bookingformsreasontypes;
      } catch (error) {
        console.log(error);
      }
      // this.busy = false;
    },
    async load(offset, limit) {
      if (!offset) {
        this.currentpage = 1;
        offset = 0;
      }

      this.btable_items = [];

      this.btable_busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        issued_at: [
          this.issued_at.startDate
            ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
            : null,
          this.issued_at.endDate
            ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        event: this.event,
        slac: this.slac,
        blac: this.blac,
        payby: this.payby,
        reason: this.reason,
        agent: this.agent,
        status: this.status,
        yourref: this.yourref,
        comments: this.comments,
        id: this.id.length > 0 ? this.id.join(",") : null,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query bookingforms(
              $limit: Int
              $offset: Int
              $id: String
              $issued_at: [String]
              $event: String
              $slac: String
              $blac: String
              $payby: String
              $reason: String
              $agent: String
              $status: String
              $yourref: String
              $comments: String
            ) {
              bookingforms(
                limit: $limit
                offset: $offset
                id: $id
                issued_at: $issued_at
                event: $event
                slac: $slac
                blac: $blac
                payby: $payby
                reason: $reason
                agent: $agent
                status: $status
                yourref: $yourref
                comments: $comments
              ) {
                id
                payby
                reason
                date
                blac
                value
                currency
                country
                event
                slac
                charge
                invoiceno
                yourref
                comments
                status
                agent
                modified
                rows
              }
            }
          `,
          variables,
        });
        if (limit > this.limit) {
          return response.data.bookingforms;
        }

        this.rows = 0;
        if (response.data.bookingforms.length > 0) {
          this.btable_items = response.data.bookingforms;
          this.rows = response.data.bookingforms[0].rows;
        }

        this.errormessage = ""

        this.$store.dispatch("bookingforms")

      } catch (error) {
        console.log(error);
      }
      this.btable_busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      switch (a) {
        case "etr":
          return this.btable_selected.length > 0 ? false : true;
        case "email":
          return this.btable_selected.length > 0 ? false : true;
      }
    },

    async deleteit() {
      let rows = this.cleanit(this.btable_selected);
      rows.forEach((r) => delete r.modified);

      let variables = { rows };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation deletebookingforms($rows: [Bookingform_input]) {
              deletebookingforms(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.errormessage = ""
        await this.load();

      } catch (error) {
        this.errormessage = error
        console.log(error);

      }

    },
  },
};
</script>

<style></style>